import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Input, InputNumber } from 'formik-antd';
import { FormInput, Box } from 'atoms';

const { TextArea } = Input;
const { Title } = Typography;

export function LRSenderDetails({ isEditMode, setSource }) {
	return (
		<Box backgroundColor="#f5f5f5" padding="1.5rem" style={{ width: '100%' }}>
			<div style={{ textAlign: 'center' }}>
				<Title level={4}>Sender</Title>
			</div>
			<Row>
				<Col span={24}>
					<FormInput name="sender_name" label="Name *">
						<Input disabled={!isEditMode} name="sender_name" placeholder="Sender" />
					</FormInput>
				</Col>
				<Col span={24}>
					<FormInput name="sender_address" label="Address *">
						<TextArea
							disabled={!isEditMode}
							name="sender_address"
							placeholder="Address"
							maxLength={200}
						/>
					</FormInput>
				</Col>
			</Row>
			<Row>
				<Col span={12}>
					<FormInput name="sender_pincode" label="Pincode *">
						<InputNumber
							disabled={!isEditMode}
							name="sender_pincode"
							placeholder="Pincode"
							controls={false}
							precision={0}
							style={{ width: '100%' }}
							onChange={(value) => setSource(value, 'source')}
						/>
					</FormInput>
				</Col>
				<Col span={12}>
					<FormInput name="source_location" label="Origin *">
						<Input
							disabled
							name="source_location"
							placeholder="Origin"
							style={{ width: '100%' }}
						/>
					</FormInput>
				</Col>
			</Row>
		</Box>
	);
}

LRSenderDetails.propTypes = {
	isEditMode: PropTypes.bool,
	setSource: PropTypes.func,
};
